import { joinIdentifierPath, splitIdentifierPath } from './utils';

interface Node {
  name: string;
  path: string;

  children: Map<string, Node>;
}

function createNode(name: string, path: string) {
  return {
    name,
    path,
    children: new Map(),
  };
}

/**
 * 按照标识符来构建一棵树
 */
export class IdentifierPathTree {
  private tree: Node = createNode('', '');

  /**
   * 传入所有标识符列表
   * @param list
   */
  constructor(list: string[]) {
    this.build(list);
  }

  includes(identifier: string) {
    const section = splitIdentifierPath(identifier);
    let current = this.tree;

    for (const name of section) {
      if (!current.children.has(name)) {
        return false;
      }

      current = current.children.get(name)!;
    }

    return true;
  }

  getTree() {
    return this.tree;
  }

  getAllPaths() {
    const list: string[] = [];

    const walk = (node: Node) => {
      list.push(node.path);
      for (const child of node.children.values()) {
        walk(child);
      }
    };

    this.tree.children.forEach(walk);

    return list;
  }

  private build(list: string[]) {
    const insert = (paths: string[], parent: Node) => {
      const name = paths.shift();
      if (!name) {
        return;
      }

      if (!parent.children.has(name)) {
        const path = joinIdentifierPath(parent.path, name);
        const node = createNode(name, path);
        parent.children.set(name, node);
      }

      insert(paths, parent.children.get(name)!);
    };

    for (const item of list) {
      const paths = splitIdentifierPath(item).slice();
      insert(paths, this.tree);
    }
  }
}
